import { render, staticRenderFns } from "./formDownload.vue?vue&type=template&id=6f2bfcc9"
import script from "./formDownload.vue?vue&type=script&lang=js"
export * from "./formDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports